module.exports = __webpack_public_path__ + "img/PG8-1-953x400.1183feb6.png";